import { SiteMetadataMarketing } from '../../hooks/useSiteMetadata'
import { mountThirdPartyScript } from './iubenda'

declare let window: {
  intercomSettings: {
    app_id: string
  }
  uetq: []
}

export const loadThirdPartyScripts = (data: SiteMetadataMarketing, anonymousId?: string) => {
  // Functionality
  if (data.intercomAppId) {
    window.intercomSettings = {
      app_id: data.intercomAppId,
    }
    mountThirdPartyScript('functionality', (script) => {
      script.innerText = `
        (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + ${JSON.stringify(
          data.intercomAppId
        )};var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
      `
    })
  }

  // Marketing
  if (window.uetq) {
    mountThirdPartyScript('marketing', (script) => {
      script.innerText = `
        window.uetq = window.uetq || [];
        window.uetq.push('consent', 'update', {
        'ad_storage': 'granted'
        });
      `
    })
  }

  if (data.firstPromoterId && data.firstPromoterDomain) {
    mountThirdPartyScript('marketing', (script) => {
      script.innerText = `
        (function(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src='https://cdn.firstpromoter.com/fprom.js',t.onload=t.onreadystatechange=function(){var t=this.readyState;if(!t||"complete"==t||"loaded"==t)try{$FPROM.init("${data.firstPromoterId}","${data.firstPromoterDomain}")}catch(t){}};var e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(t,e)})();
      `
    })
  }

  if (data.profitWellRetainAuth) {
    mountThirdPartyScript('marketing', (script) => {
      script.id = 'profitwell-js'
      script.dataset.pwAuth = data.profitWellRetainAuth
      script.innerText = `
        (function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)}; a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);})(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');
        profitwell('start', {});
      `
    })
  }

  if (data.segmentId) {
    mountThirdPartyScript('marketing', (script) => {
      script.innerText = `
        !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.4.0";
        ${`analytics.load("${data.segmentId}", { integrations: { All: true } });`}
        analytics.page({}, { anonymousId: "${anonymousId}" });
        }}();
      `
    })
  }

  if (data.navatticId) {
    mountThirdPartyScript('marketing', (script) => {
      script.id = 'navattic-js'
      script.innerText = `
        void 0 === window.navatticQueue &&
          (window.navatticQueue = [],
          window.navattic = new Proxy({}, {
            get: function(n, t, e) {
              return function() {
                for (var n = arguments.length, t = Array(n), e = 0; e < n; e++) t[e] = arguments[e];
                return navatticQueue.push({ function: t, arguments: t });
              }
            }
          }));

        (function(d, s, id, key) {
          var js = d.createElement(s);
          js.async = true;
          js.src = 'https://js.navattic.com/sdk.js';
          js.setAttribute('data-key', key);
          var m = d.getElementsByTagName(s)[0];
          m.parentNode.insertBefore(js, m);
        })(document, 'script', 'navattic-sdk', "${data.navatticId}");
    `
    })
  }
}
